/**
 * S8 (ADLS Gen2) registrations of the storage explorer: row-menu items (the S8-owned registry), toolbar extensions
 * (view switch, New folder) and the Object Explorer tree items. Called once from the feature module.
 */
import { registerHnsRowMenuItems } from './hnsRowMenuItems';
import { registerHnsToolbarExtensions } from './hnsToolbarExtensions';
import { registerHnsTreeExtension } from './tree/hnsTreeExtension';

export function registerS8HnsExtensions(): () => void {
  const unregister = [registerHnsRowMenuItems(), registerHnsToolbarExtensions(), registerHnsTreeExtension()];
  return () => unregister.forEach((dispose) => dispose());
}
